module.exports = __webpack_public_path__ + "img/image-second-son.fc7f810f.svg";